import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PublicHeader } from "@/components/PublicHeader";
import { Footer } from "@/components/Footer";
import { SEO } from "@/components/SEO";
import { SEO_SOLUTIONS } from "@/lib/seo-defs";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { ArrowRight, Package as PackageIcon, CheckCircle2 } from "lucide-react";
import { api } from "@/lib/api";

export default function SolutionsPage() {
  const [packages, setPackages] = useState([]);
  useEffect(() => {
    api.get("/public/packages").then(r => setPackages(r.data || [])).catch(() => {});
  }, []);
  return (
    <div className="min-h-screen">
      <SEO {...SEO_SOLUTIONS} />
      <PublicHeader />
      <section className="pt-28 pb-12 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <Badge className="bg-[#EAF0FF] text-[#2D6BFF] border-0">Soluzioni</Badge>
          <h1 className="mt-4 font-display text-4xl sm:text-5xl font-bold tracking-tight text-slate-900 max-w-3xl">
            Quattro modalità di intervento, adatte a ogni fase aziendale.
          </h1>
          <p className="mt-5 text-lg text-slate-600 leading-relaxed max-w-3xl">
            Dai un'occhiata ai nostri pacchetti. Le fasce di prezzo sono indicative: la stima reale viene definita dopo il check-up.
          </p>
        </div>
      </section>

      <section className="py-12 bg-[#F6F8FC]">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 grid grid-cols-1 md:grid-cols-2 gap-6">
          {packages.map((p, idx) => (
            <div key={p.id} className={`cxo-card p-6 sm:p-8 ${idx === 1 ? "border-2 border-[#2D6BFF]" : ""}`}>
              <div className="flex items-center gap-3">
                <div className="w-11 h-11 rounded-xl bg-[#071225] text-white flex items-center justify-center">
                  <PackageIcon size={20} />
                </div>
                <div>
                  <h3 className="font-display text-xl font-bold text-slate-900">{p.name}</h3>
                  <p className="text-xs text-slate-500">Durata indicativa: {p.duration}</p>
                </div>
                {idx === 1 && <Badge className="ml-auto bg-[#EAF0FF] text-[#2D6BFF] border-0">Più richiesto</Badge>}
              </div>
              <p className="mt-4 text-sm text-slate-600 leading-relaxed">{p.description}</p>
              <ul className="mt-4 space-y-1.5">
                {(p.features || []).map(f => (
                  <li key={f} className="flex gap-2 text-sm text-slate-700"><CheckCircle2 size={16} className="text-[#1F9D6A] shrink-0 mt-0.5" /> {f}</li>
                ))}
              </ul>
              <div className="mt-5 pt-4 border-t border-slate-200 flex items-baseline gap-2">
                {p.monthly_price && <><span className="text-2xl font-bold cxo-tabular text-slate-900">€{p.monthly_price.toLocaleString('it-IT')}</span><span className="text-xs text-slate-500">/mese (indicativo)</span></>}
                {p.one_time_price && !p.monthly_price && <><span className="text-2xl font-bold cxo-tabular text-slate-900">€{p.one_time_price.toLocaleString('it-IT')}</span><span className="text-xs text-slate-500">una tantum</span></>}
              </div>
              <Link to="/checkup" className="mt-5 block">
                <Button className="w-full bg-[#2D6BFF] hover:bg-[#1F57F2] text-white">Avvia il check-up <ArrowRight size={16} className="ml-2" /></Button>
              </Link>
            </div>
          ))}
        </div>
        <p className="text-center mt-8 text-sm text-slate-500">I prezzi reali dipendono dal manager selezionato e dalle condizioni concordate.</p>
      </section>
      <Footer />
    </div>
  );
}
